import DisableButtonMutationCallBack from "./disable-action-element-observer";

export class MessageObserver {
    static startObservers = () => {
        const canvasDiv = document.querySelector(".webchat");
        const config = { childList: true, subtree: true };

        new MutationObserver(DisableButtonMutationCallBack).observe(canvasDiv, config);
    }
}